import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { reduxForm, getFormValues, Field, reset } from 'redux-form'
import { Confirm, Modal, Button, Header } from 'semantic-ui-react'
import r from 'reactotron-react-js'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { Cont, ModalAction } from './styled'
import {
  createUserRole,
  fetchUsersRole,
  createUser,
  fetchRoles,
} from 'ducks/roleMan'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import { Toaster } from '@blueprintjs/core'
let toast = Toaster.create({ message: '', show: false })

const FormUserRoleModal = props => {
  const {
    handleSubmit,
    data,
    valueForm,
    show,
    title,
    changeShow,
    showConfirm,
    setShowConfirm,
  } = props
  const onDataCreated = (pageSize, setCurrentPage) => itemCount => {
    r.log({ pageSize, setCurrentPage, itemCount })
    if (itemCount <= pageSize) {
      setCurrentPage(0)
    } else {
      let targetPage = Math.ceil(itemCount / pageSize)
      setCurrentPage(targetPage - 1)
    }
  }
  return (
    <div>
      <Modal
        size="tiny"
        open={show}
        closeOnEscape={false}
        closeOnDimmerClick={false}
        onMount={() => onModalMount()}
      >
        <Modal.Header>{title || ''}</Modal.Header>
        <Modal.Content>
          <form onSubmit={handleSubmit(() => setShowConfirm(true))}>
            <Cont>
              {props.isAddUser ? (
                <Field
                  name="memberId"
                  label="Member"
                  options={props.membersSelectView}
                  type={type.select}
                  component={FieldInput}
                  placeHolder="Select Member"
                  require
                />
              ) : (
                <Field
                  name="roleId"
                  label="Role"
                  options={props.roles}
                  type={type.select}
                  component={FieldInput}
                  placeHolder="Select Role"
                  require
                />
              )}
              <div style={{ height: '1rem' }} />
              <div className="subCont ui form"></div>
            </Cont>
            <ModalAction>
              <Button onClick={() => closeModal()} negative>
                Cancel
              </Button>
              <Button
                type="submit"
                positive
                labelPosition="right"
                icon="save"
                content="Save"
              />
            </ModalAction>
          </form>
        </Modal.Content>
      </Modal>
      <Confirm
        size="mini"
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => submitModal()}
      />
    </div>
  )

  function submitModal() {
    setShowConfirm(false)
    if (props.isAddUser) {
      let hasMember = props.usersRole.find(
        item => item.username.toUpperCase() === valueForm.memberId.toUpperCase()
      )
      if (hasMember) {
        toast.clear()
        toast.show({
          message: hasMember.username + ' was already',
          intent: 'warning',
          timeout: 10000,
        })
        closeModal()
      } else {
        let memberId = props.membersSelectView.find( item => item.value === valueForm.memberId)
        props.createUser(memberId, closeModal,onDataCreated(props.tablePageSize, props.setCurrentPage))
      }
    } else {
      let role = props.roles.find(item => item.value === valueForm.roleId)
      let user = props.usersRole.find(item => item.userId === data.userId)
      let hasRole = user.masterUserRoles.find(
        item => item.roleName === role.text
      )
      if (hasRole) {
        toast.clear()
        toast.show({
          message: role.text + ' was already',
          intent: 'warning',
          timeout: 10000,
        })
        closeModal()
      } else {
        props.createUserRole(
          {
            userId: data.userId,
            username: data.username,
            roleId: valueForm.roleId,
          },
          closeModal,
          onDataCreated(props.tablePageSize, props.setCurrentPage)
        )
      }
    }
  }

  function closeModal() {
    changeShow()
    props.dispatch(reset('formUserRoleModal'))
  }

  function onModalMount() {
    props.fetchRoles()
    if (props.membersSelectView.length == 0) {
      // props.getHrmsMembers()
      props.getAllMembers()
    }
  }
}

const validate = values => {
  const errors = {}
  if (!values.memberId) {
    errors.memberId = 'Required!'
  }
  if (!values.roleId) {
    errors.roleId = 'Required!'
  }
  return errors
}

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      // memberId:0,
      // roleId:0,
    },
    valueForm: getFormValues('formUserRoleModal')(state),
    membersSelectView: state.member.members.map(m => ({
      id: m.id,
      value: m.username,
      text: `${m.firstnameEn} ${m.lastnameEn}`,
    })),
    roles: state.roleMan.roles
      ? state.roleMan.roles.map(item => ({ value: item.id, text: item.name }))
      : [],
    usersRole: state.roleMan.usersRole,
  }
}

const mapDispatchToProps = {
  createUserRole,
  fetchUsersRole,
  fetchRoles,
  createUser,
  getHrmsMembers,
  getAllMembers
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'formUserRoleModal',
    validate: validate,
    enableReinitialize: true,
  }),
  withState('showConfirm', 'setShowConfirm', false),
  lifecycle({
    componentDidMount() {
      // this.props.fetchUsersRole();
      this.props.fetchRoles()
    },
    componentWillReceiveProps(nextProp) {},
  })
)

export default enhance(FormUserRoleModal)
